import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState, StatusNotification } from "shared/interfaces/status-notifications-interfaces";

const StatusNotificationsSlice = createSlice({
  name: 'StatusNotificationsSlice',
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<StatusNotification>) => {
      const newNotification = {
        id: Date.now().toString(),
        message: action.payload.message,
        type: action.payload.type,
      };
      state.notificationList.push(newNotification);
    },
    removeNotification: (state, action) => {
      const index = state.notificationList.findIndex(notification => notification.id === action.payload);
      if (index !== -1) {
        state.notificationList.splice(index, 1);
      }
    },
  },
  extraReducers() {
  }
});

export const { showNotification, removeNotification } = StatusNotificationsSlice.actions;
export default StatusNotificationsSlice.reducer;